import SearchPage from '../../components/Pages/SearchPage'

const SearchLayout = () => {
  return (
    <div>
      <SearchPage />
    </div>
  )
}

export default SearchLayout
